import * as React from 'react';
import { SlotPathRenderMode } from '../../../common/models/slot-path-render-mode';
import { PicDropdown } from '@cardinalblue/pic-collage-cms-ui';

type Props = {
  pathRenderMode: SlotPathRenderMode | null;
  onPathRenderModeChange: (pathRenderMode: SlotPathRenderMode | null) => void;
};

export function SlotPathRenderModeDropdown({ pathRenderMode, onPathRenderModeChange }: Props) {
  return (
    <PicDropdown<{ label: string; value: SlotPathRenderMode | '' }>
      itemGroups={[
        {
          title: null,
          items: [
            { label: 'none', value: '' },
            ...Object.values(SlotPathRenderMode).map((mode) => ({
              label: mode,
              value: mode,
            })),
          ],
        },
      ]}
      placeholder="none"
      value={pathRenderMode}
      itemLabelGetter={(item) => item.label}
      itemValueGetter={(item) => item.value}
      onSelect={(item) => onPathRenderModeChange(item.value === '' ? null : item.value)}
    />
  );
}
